import { requestJson } from "../api/apiClient";

const ADMIN_BASE = "/api/admin/automotive";
const PUBLIC_BASE = "/api/v1/automap";

export function fetchAdminDealers(params = {}) {
  const qs = new URLSearchParams(params).toString();
  return requestJson(`${ADMIN_BASE}/dealers${qs ? `?${qs}` : ""}`);
}

export function runAdminDealerBulkAction(dealerIds, action, payload = {}) {
  return requestJson(`${ADMIN_BASE}/dealers/bulk-actions`, {
    method: "POST",
    body: JSON.stringify({ dealerIds, action, ...payload }),
  });
}

export function fetchAdminDealer(dealerId) {
  return requestJson(`${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}`);
}

export function createAdminDealer(payload) {
  return requestJson(`${ADMIN_BASE}/dealers`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateAdminDealer(dealerId, payload) {
  return requestJson(`${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function runAdminDealerAction(dealerId, action, payload = {}) {
  return requestJson(`${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/actions`, {
    method: "POST",
    body: JSON.stringify({ action, ...payload }),
  });
}

export function updateAdminDealerVerificationChecklist(dealerId, checklist) {
  return requestJson(`${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/verification-checklist`, {
    method: "PATCH",
    body: JSON.stringify({ checklist }),
  });
}

export function fetchAdminDealerContacts(dealerId) {
  return requestJson(`${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/contacts`);
}

export function createAdminDealerContact(dealerId, payload) {
  return requestJson(`${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/contacts`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateAdminDealerContact(dealerId, contactId, payload) {
  return requestJson(
    `${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/contacts/${encodeURIComponent(contactId)}`,
    { method: "PATCH", body: JSON.stringify(payload) }
  );
}

export function deleteAdminDealerContact(dealerId, contactId) {
  return requestJson(
    `${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/contacts/${encodeURIComponent(contactId)}`,
    { method: "DELETE" }
  );
}

export function fetchAdminDealerLocations(dealerId) {
  return requestJson(`${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/locations`);
}

export function createAdminDealerLocation(dealerId, payload) {
  return requestJson(`${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/locations`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateAdminDealerLocation(dealerId, locationId, payload) {
  return requestJson(
    `${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/locations/${encodeURIComponent(locationId)}`,
    { method: "PATCH", body: JSON.stringify(payload) }
  );
}

export function deleteAdminDealerLocation(dealerId, locationId) {
  return requestJson(
    `${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/locations/${encodeURIComponent(locationId)}`,
    { method: "DELETE" }
  );
}

export function fetchAdminDealerUsers(dealerId) {
  return requestJson(`${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/users`);
}

export function createAdminDealerUser(dealerId, payload) {
  return requestJson(`${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/users`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateAdminDealerUser(dealerId, userId, payload) {
  return requestJson(
    `${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/users/${encodeURIComponent(userId)}`,
    { method: "PATCH", body: JSON.stringify(payload) }
  );
}

export function deleteAdminDealerUser(dealerId, userId) {
  return requestJson(
    `${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/users/${encodeURIComponent(userId)}`,
    { method: "DELETE" }
  );
}

export function startAdminDealerPortalSession(dealerId, payload = {}) {
  return requestJson(
    `${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/dealer-portal-session`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  );
}

export function fetchAdminDealerNotes(dealerId) {
  return requestJson(`${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/notes`);
}

export function createAdminDealerNote(dealerId, payload) {
  return requestJson(`${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/notes`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function deleteAdminDealerNote(dealerId, noteId) {
  return requestJson(
    `${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/notes/${encodeURIComponent(noteId)}`,
    { method: "DELETE" }
  );
}

export function fetchAdminDealerActivity(dealerId, limit = 50) {
  const qs = new URLSearchParams({ limit: String(limit) }).toString();
  return requestJson(`${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/activity?${qs}`);
}

export function fetchAdminDealerLeadPreferences(dealerId) {
  return requestJson(`${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/lead-preferences`);
}

export function updateAdminDealerLeadPreferences(dealerId, payload) {
  return requestJson(`${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/lead-preferences`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function fetchAdminDealerVerifications() {
  return requestJson(`${ADMIN_BASE}/dealers/verifications`);
}

export function fetchAdminDealerTrials() {
  return requestJson(`${ADMIN_BASE}/dealers/trials`);
}

export function fetchAdminDealerProspects(params = {}) {
  const qs = new URLSearchParams(params).toString();
  return requestJson(`${ADMIN_BASE}/dealers/prospects${qs ? `?${qs}` : ""}`);
}

export function fetchAdminDealerProspect(prospectId) {
  return requestJson(`${ADMIN_BASE}/dealers/prospects/${encodeURIComponent(prospectId)}`);
}

export function updateAdminDealerProspect(prospectId, payload) {
  return requestJson(`${ADMIN_BASE}/dealers/prospects/${encodeURIComponent(prospectId)}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function convertAdminDealerProspect(prospectId, payload = {}) {
  return requestJson(`${ADMIN_BASE}/dealers/prospects/${encodeURIComponent(prospectId)}/convert`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function submitDealerProspect(payload) {
  return requestJson(`${PUBLIC_BASE}/dealer-prospects`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function trackDealerEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[dealer-event]", eventType, metadata);
  }
}
